import "./AirConditioning.module.css";
import Header from "@/reusable_sections/Header";
import Airconditioninghero from "./sections/Airconditioninghero";
import ExpertAcInstallation from "./sections/ExpertAcInstallation";
import HvacSystemShowcase from "./sections/HvacSystemShowcase";
import MaintenanceServices from "./sections/MaintenanceServices";
import SectorsGrid from "./sections/SectorsGrid";
import CustomerTestimonialsCarousel from "./sections/CustomerTestimonialsCarousel";
import Footer from "@/reusable_sections/Footer";
export default function AirConditioningPage() {
  return <div>
      <Header />
      <Airconditioninghero />
      <ExpertAcInstallation />
      <HvacSystemShowcase />
      <MaintenanceServices />
      <SectorsGrid />
      <CustomerTestimonialsCarousel />
      <Footer />
    </div>;
}